import React, { useEffect, useState } from 'react';
import TableComponent from './Tablecomponent';
import { Box, Chip, Link, Paper, Typography } from '@mui/material';
import { getSongStatusBgColor } from '../../../_helpers/reusablefunctions/getColor';
import { useDispatch, useSelector } from 'react-redux';
import { getDateAsPerFormat } from '../../../_helpers/reusablefunctions/dateSetter';
import ApiService from '../../../_services/ApiService';
import { useLocation } from 'react-router-dom';
import PayoutModal from './PayoutModal';
import { setLoader } from '../../../redux';
export default function PayoutDetails({ studioDetail }) {
    const location = useLocation()
    const dispatch = useDispatch()
    const [historyDetailRow, setHistoryDetailRow] = useState(null);
    const [openPayout, setOpenPayout] = useState(false);
    const [reference_id, setReference_id] = useState('');
    const [historyData, setHistoryData] = useState([]);
    const [statusPaid, setStatusPaid] = useState('');
    const getId = location.state.state.data
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [total_count, setTotal_count] = useState(0);
    const [payment_date, setPayment_date] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [comment, setComment] = useState('');
    const netRevenue = studioDetail.length ? studioDetail[0].net_revenue : 0;

    const getPayoutDetails = async () => {
        try {
            const [payoutStatusRes] = await Promise.all([
                ApiService.get('payout_status', { publisher_id: getId?.studio_id, publisher_type: "studio", limit: limit, offset: offset })
            ]);

            // setPayoutAmount(revenueLedgerRes.data);
            setTotal_count(payoutStatusRes.data?.total_count);
            setHistoryData(payoutStatusRes.data?.results);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            // dispatch(setLoader(false));
        }
    };

    useEffect(() => {
        if (getId?.studio_id) {
            // dispatch(setLoader(true));
            getPayoutDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getId?.studio_id, offset, limit])

    const columns = [
        { id: 'amount_paid', field: 'amount_paid', label: 'Requested Amount' },
        {
            id: 'payouttype',
            label: 'Payout Type',
            template: (row) => <Box className="d-flex align-items-center">{row?.payout_type}</Box>
        },
        { id: 'payment_date', field: 'payment_date', label: 'Payment Date' },
        {
            id: 'requestedon',
            label: 'Requested On',
            template: (row) => (
                <Box className="d-flex align-items-center">
                    {getDateAsPerFormat(row.requested_date, 'DD Mon, YYYY')}
                </Box>
            )
        },
        {
            id: 'status', label: 'Status', headerName: '', flex: 1, template: (row) => {
                return (
                    <Box className=''>
                        <Typography variant='subtitle1' sx={{ color: row?.status == "Paid" ? '#00C853' : '#F14950 ' }}>{row?.status}</Typography>
                    </Box>
                )
            }
        },
        {
            id: 'Comments', label: 'Comment', headerName: '', flex: 1, template: (row) => {
                return (
                    <Box className=''>
                        <Typography variant='subtitle1' sx={{ fontSize: '14px' }}>{row?.comment || ''}</Typography>
                    </Box>
                )
            }
        },
        {
            id: 'action', label: '', headerName: '', flex: 1, template: (row) => {
                return (
                    row?.status !== "Paid" ? <Box className='text-decoration-none viewDetailgradient cursorPointer' onClick={() => { setOpenPayout(true); setHistoryDetailRow(row) }} >Pay Amount</Box> : ''
                )
            }
        },
    ];

    const submitRequest = (e) => {
        const formData = new FormData();
        formData.append('status', statusPaid);
        formData.append('payment_date', payment_date);
        formData.append('reference_id', reference_id);
        formData.append('payout_type', paymentMethod);
        formData.append('comment', comment);

        dispatch(setLoader(true));

        ApiService.put('payout_status', formData, null, historyDetailRow?.id)
            .then(() => getPayoutDetails())
            .finally(() => { setOpenPayout(false); dispatch(setLoader(false)) });
    };

    return (
        <Paper sx={{ width: '100%', mb: 5, mt: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h6' className='p-3'>Payout Detail</Typography>
                <Chip label={`Total Net Revenue: ${netRevenue}`} sx={{mr:1 , fontSize:'14px' , fontWeight:'bold'}} />
            </Box>
            <TableComponent columns={columns} data={historyData || []} total_count={total_count}
                page={offset} setPage={setOffset} rowsPerPage={limit} setRowsPerPage={setLimit} />
            <PayoutModal
                payoutAmount={historyDetailRow}
                open={openPayout}
                payment_date={payment_date}
                setPayment_date={setPayment_date}
                setReference_id={setReference_id}
                reference_id={reference_id}
                handleClose={() => setOpenPayout(false)}
                submitRequest={submitRequest}
                statusPaid={statusPaid}
                setStatusPaid={setStatusPaid}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                comment={comment}
                setComment={setComment}
            />
        </Paper>
    );
}
